import UmlShape from './UmlShape';

// LET OP — afwijking t.o.v. design V1 note: UmlClassShape extendt UmlShape,
// NIET UmlCompositeShape. Reden: een class bevat geen genest UmlShape (geen
// Composite-relatie), alleen een caption (UmlCaption, een UmlFreePoint) en
// members (UmlMemberText[], geen UmlDiagramItem). Die twee horen niet in
// hetzelfde children[]/addChild()-contract als UmlCompositeShape — dat
// contract is specifiek voor shape-in-shape containment (Package->Class).
// Vandaar eigen velden i.p.v. hergebruik van children[].
class UmlClassShape extends UmlShape {
  constructor(id, x, y, w, h, caption, description, inherits, collapsed) {
    super(id, x, y, w, h);
    this.caption = caption; // UmlCaption
    this.members = []; // UmlMemberText[]
    this.description = description || null; // vrije tekst, XMLDoc/JSDoc-achtig, optioneel
    this.inherits = inherits || []; // string[] namen van base class/interfaces (uit C#-import base-list)
    this.kind = 'class'; // discriminant voor UmlShapeSerializer.fromPlainShape (JSON heeft geen class-info)
    this.setCollapsed(collapsed || false); // collapsed/setCollapsed zelf zitten op UmlShape (generiek voor elke box-shape)
  }

  setDescription(description) {
    this.description = description;
  }

  setInherits(inherits) {
    this.inherits = inherits;
  }

  addMember(memberText) {
    this.members.push(memberText);
  }

  removeMember(memberId) {
    this.members = this.members.filter(function filterOutMember(member) {
      return member.id !== memberId;
    });
  }
}

export default UmlClassShape;
